/** @jsxImportSource @emotion/react */
import { BaseDialog } from "@erinfo/brand-ui/src/storybook/other/dialogs/BaseDialog"
import InfoIcon from "@mui/icons-material/InfoRounded"
import { CameraPermissionHelper } from "@erinfo/brand-ui/src/storybook/other/camera-permission-helper"
import { StyledButton } from "@erinfo/brand-ui/src/StyledComponents/v2"

interface IProps {
  isOpen: boolean
  onClose: () => void
}

export const CammeraPermissionDialog = ({ isOpen, onClose }: IProps) => {
  return (
    <BaseDialog
      showCloseButton
      open={isOpen}
      handleClose={onClose}
      Icon={<InfoIcon sx={{ opacity: 0.54, mr: 2 }} />}
      title="Camera Permissions"
      renderActions={() => (
        <StyledButton onClick={onClose}>Cancel</StyledButton>
      )}
      contentSx={(theme) => ({
        paddingLeft: 0,
        paddingRight: 0,
        paddingBottom: 0,
        "& >div:first-of-type": {
          [theme.breakpoints.down(`sm`)]: {
            height: `50vh`,
            width: `90vw`,
            minWidth: `100%`,
          },
          [theme.breakpoints.up(`sm`)]: {
            width: `400px`,
            height: `500px `,
            minWidth: `100%`,
          },
        },
      })}
    >
      <CameraPermissionHelper />
    </BaseDialog>
  )
}
